
import DivSpan from "@/components/DivSpan"
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'

export default {
name: 'base-info',
components: {DivSpan,InlineXSwitch},
props: ['supManageInfo']
}



// WEBPACK FOOTER //
// ./src/page/supplier/view/manage-info.vue